// Lets a driver take a photo or pick one from their gallery on a native
// app build (Capacitor), returning a browser File object compatible with
// the existing UploadFile({ file }) flow already used across the app for
// fuel receipts and BOLs. On the web/PWA build this isn't used at all --
// callers keep their existing <input type="file"> for that case.
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';
import { isNativePlatform } from './backgroundLocation';

export { isNativePlatform };

// Resolves to a File, or null if the driver cancelled (not an error --
// callers should just no-op on null).
export async function pickPhotoNative(filenamePrefix = 'photo') {
  if (!isNativePlatform()) return null;
  try {
    const photo = await Camera.getPhoto({
      quality: 80,
      resultType: CameraResultType.Uri,
      source: CameraSource.Prompt, // driver picks "Take Photo" or "Choose from Gallery"
      promptLabelHeader: 'Add Photo',
      promptLabelPhoto: 'Choose from Gallery',
      promptLabelPicture: 'Take Photo',
    });
    const res = await fetch(photo.webPath);
    const blob = await res.blob();
    const ext = photo.format || 'jpg';
    return new File([blob], `${filenamePrefix}-${Date.now()}.${ext}`, { type: blob.type || `image/${ext}` });
  } catch (err) {
    if (err?.message === 'User cancelled photos app') return null;
    throw err;
  }
}
